module.exports = __webpack_public_path__ + "static/media/subsidy.1493f07a.jpg";